import { render, staticRenderFns } from "./UserPerm.vue?vue&type=template&id=2ef51bef"
import script from "./UserPerm.vue?vue&type=script&lang=js"
export * from "./UserPerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports